var _style, _metadata, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F4CB;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0.1,
    y: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.1,
    cy: 22,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.9,31.1v-2.9h-7.9c-1,0-1.7-0.2-2.2-0.7s-0.7-1-0.7-1.8c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.3-0.6 c0.2-0.2,0.3-0.5,0.5-0.6c0.2-0.2,0.3-0.5,0.6-0.8L21.8,12c0.5-0.7,1-1.2,1.4-1.6c0.3-0.3,0.8-0.5,1.2-0.5c1.6,0,2.4,0.9,2.4,2.7 v12.1h0.7c0.8,0,1.5,0.1,1.9,0.3s0.7,0.7,0.7,1.5c0,0.6-0.2,1-0.6,1.3c-0.4,0.3-1,0.4-1.8,0.4h-0.9v2.9c0,0.8-0.2,1.4-0.5,1.8 c-0.4,0.4-0.8,0.6-1.4,0.6s-1-0.2-1.4-0.6C23.1,32.5,22.9,31.9,22.9,31.1L22.9,31.1z M16.2,24.7h6.7v-9.1L16.2,24.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt4);
export default __webpack_public_path__ + "static/media/CT4.fc299d792986461e5c7b4b29e7249917.svg";
export { ForwardRef as ReactComponent };